{
    "33417": {
        "position": {
            "x": 87,
            "y": 43,
            "z": 1
        },
        "key": "33417",
        "tag": "goodspawn"
    },
    "Bp8Mo": {
        "position": {
            "x": 0,
            "y": 30,
            "z": 1
        },
        "key": "Bp8Mo",
        "tag": "goodspawn"
    },
    "bjRna": {
        "position": {
            "x": 0,
            "y": 31,
            "z": 1
        },
        "key": "bjRna",
        "tag": "goodspawn"
    },
    "N5oWT": {
        "position": {
            "x": 0,
            "y": 32,
            "z": 1
        },
        "key": "N5oWT",
        "tag": "goodspawn"
    },
    "Dt2qV": {
        "position": {
            "x": 4,
            "y": 33,
            "z": 1
        },
        "key": "Dt2qV",
        "tag": "badspawn"
    },
    "_xQ_5": {
        "position": {
            "x": 2,
            "y": 32,
            "z": 1
        },
        "key": "_xQ_5",
        "tag": "badspawn"
    },
    "e1kAk": {
        "position": {
            "x": 5,
            "y": 30,
            "z": 1
        },
        "key": "e1kAk",
        "tag": "badspawn"
    },
    "lgGhV": {
        "position": {
            "x": 5,
            "y": 32,
            "z": 1
        },
        "key": "lgGhV",
        "tag": "badspawn"
    },
    "lMidq": {
        "position": {
            "x": 4,
            "y": 31,
            "z": 1
        },
        "key": "lMidq",
        "tag": "badspawn"
    },
    "KwTWq": {
        "position": {
            "x": 0,
            "y": 37,
            "z": 1
        },
        "key": "KwTWq",
        "tag": "goodspawn"
    },
    "oLzoS": {
        "position": {
            "x": 1,
            "y": 37,
            "z": 1
        },
        "key": "oLzoS",
        "tag": "goodspawn"
    },
    "00lKB": {
        "position": {
            "x": 0,
            "y": 36,
            "z": 1
        },
        "key": "00lKB",
        "tag": "goodspawn"
    },
    "Yvjbm": {
        "position": {
            "x": 3,
            "y": 35,
            "z": 1
        },
        "key": "Yvjbm",
        "tag": "badspawn"
    },
    "evfzy": {
        "position": {
            "x": 3,
            "y": 38,
            "z": 1
        },
        "key": "evfzy",
        "tag": "badspawn"
    },
    "a01J_": {
        "position": {
            "x": 5,
            "y": 37,
            "z": 1
        },
        "key": "a01J_",
        "tag": "badspawn"
    },
    "C2Hix": {
        "position": {
            "x": 5,
            "y": 35,
            "z": 1
        },
        "key": "C2Hix",
        "tag": "badspawn"
    },
    "yajqZ": {
        "position": {
            "x": 2,
            "y": 36,
            "z": 1
        },
        "key": "yajqZ",
        "tag": "badspawn"
    },
    "JDZue": {
        "position": {
            "x": 0,
            "y": 42,
            "z": 1
        },
        "key": "JDZue",
        "tag": "goodspawn"
    },
    "Hxw0e": {
        "position": {
            "x": 0,
            "y": 41,
            "z": 1
        },
        "key": "Hxw0e",
        "tag": "goodspawn"
    },
    "6auhR": {
        "position": {
            "x": 1,
            "y": 42,
            "z": 1
        },
        "key": "6auhR",
        "tag": "goodspawn"
    },
    "lX4iE": {
        "position": {
            "x": 5,
            "y": 42,
            "z": 1
        },
        "key": "lX4iE",
        "tag": "badspawn"
    },
    "wUeGo": {
        "position": {
            "x": 3,
            "y": 40,
            "z": 1
        },
        "key": "wUeGo",
        "tag": "badspawn"
    },
    "MMkjH": {
        "position": {
            "x": 4,
            "y": 44,
            "z": 1
        },
        "key": "MMkjH",
        "tag": "badspawn"
    },
    "jvNkv": {
        "position": {
            "x": 2,
            "y": 43,
            "z": 1
        },
        "key": "jvNkv",
        "tag": "badspawn"
    },
    "RLZcZ": {
        "position": {
            "x": 12,
            "y": 31,
            "z": 1
        },
        "key": "RLZcZ",
        "tag": "goodspawn"
    },
    "Onxpl": {
        "position": {
            "x": 12,
            "y": 32,
            "z": 1
        },
        "key": "Onxpl",
        "tag": "goodspawn"
    },
    "Va4WJ": {
        "position": {
            "x": 11,
            "y": 31,
            "z": 1
        },
        "key": "Va4WJ",
        "tag": "goodspawn"
    },
    "jLLU9": {
        "position": {
            "x": 11,
            "y": 32,
            "z": 1
        },
        "key": "jLLU9",
        "tag": "goodspawn"
    },
    "F1-wb": {
        "position": {
            "x": 1,
            "y": 41,
            "z": 1
        },
        "key": "F1-wb",
        "tag": "goodspawn"
    },
    "xS-iQ": {
        "position": {
            "x": 0,
            "y": 38,
            "z": 1
        },
        "key": "xS-iQ",
        "tag": "goodspawn"
    },
    "MoeGf": {
        "position": {
            "x": 1,
            "y": 30,
            "z": 1
        },
        "key": "MoeGf",
        "tag": "goodspawn"
    },
    "XOk6z": {
        "position": {
            "x": 14,
            "y": 30,
            "z": 1
        },
        "key": "XOk6z",
        "tag": "badspawn"
    },
    "W1s_5": {
        "position": {
            "x": 16,
            "y": 30,
            "z": 1
        },
        "key": "W1s_5",
        "tag": "badspawn"
    },
    "ulSar": {
        "position": {
            "x": 15,
            "y": 32,
            "z": 1
        },
        "key": "ulSar",
        "tag": "badspawn"
    },
    "g-3kl": {
        "position": {
            "x": 14,
            "y": 33,
            "z": 1
        },
        "key": "g-3kl",
        "tag": "badspawn"
    },
    "b_W1I": {
        "position": {
            "x": 13,
            "y": 31,
            "z": 1
        },
        "key": "b_W1I",
        "tag": "badspawn"
    },
    "rRM1g": {
        "position": {
            "x": 12,
            "y": 33,
            "z": 1
        },
        "key": "rRM1g",
        "tag": "badspawn"
    },
    "skNzr": {
        "position": {
            "x": 16,
            "y": 33,
            "z": 1
        },
        "key": "skNzr",
        "tag": "badspawn"
    },
    "1y3wR": {
        "position": {
            "x": 15,
            "y": 37,
            "z": 1
        },
        "key": "1y3wR",
        "tag": "badspawn"
    },
    "j6cuD": {
        "position": {
            "x": 15,
            "y": 35,
            "z": 1
        },
        "key": "j6cuD",
        "tag": "badspawn"
    },
    "Xjznc": {
        "position": {
            "x": 15,
            "y": 38,
            "z": 1
        },
        "key": "Xjznc",
        "tag": "badspawn"
    },
    "h7GD5": {
        "position": {
            "x": 16,
            "y": 36,
            "z": 1
        },
        "key": "h7GD5",
        "tag": "badspawn"
    },
    "tbzGw": {
        "position": {
            "x": 12,
            "y": 37,
            "z": 1
        },
        "key": "tbzGw",
        "tag": "goodspawn"
    },
    "2oPEe": {
        "position": {
            "x": 13,
            "y": 37,
            "z": 1
        },
        "key": "2oPEe",
        "tag": "goodspawn"
    },
    "ZaX4o": {
        "position": {
            "x": 13,
            "y": 38,
            "z": 1
        },
        "key": "ZaX4o",
        "tag": "goodspawn"
    },
    "Rtwd6": {
        "position": {
            "x": 12,
            "y": 38,
            "z": 1
        },
        "key": "Rtwd6",
        "tag": "goodspawn"
    },
    "d5ufm": {
        "position": {
            "x": 14,
            "y": 36,
            "z": 1
        },
        "key": "d5ufm",
        "tag": "badspawn"
    },
    "b5nFw": {
        "position": {
            "x": 14,
            "y": 45,
            "z": 1
        },
        "key": "b5nFw",
        "tag": "badspawn"
    },
    "XalNZ": {
        "position": {
            "x": 16,
            "y": 41,
            "z": 1
        },
        "key": "XalNZ",
        "tag": "badspawn"
    },
    "9QWgF": {
        "position": {
            "x": 16,
            "y": 44,
            "z": 1
        },
        "key": "9QWgF",
        "tag": "badspawn"
    },
    "XJLL3": {
        "position": {
            "x": 14,
            "y": 42,
            "z": 1
        },
        "key": "XJLL3",
        "tag": "badspawn"
    },
    "__K3c": {
        "position": {
            "x": 12,
            "y": 43,
            "z": 1
        },
        "key": "__K3c",
        "tag": "goodspawn"
    },
    "DWPsU": {
        "position": {
            "x": 12,
            "y": 42,
            "z": 1
        },
        "key": "DWPsU",
        "tag": "goodspawn"
    },
    "O-e_-": {
        "position": {
            "x": 13,
            "y": 43,
            "z": 1
        },
        "key": "O-e_-",
        "tag": "goodspawn"
    },
    "us1Az": {
        "position": {
            "x": 13,
            "y": 42,
            "z": 1
        },
        "key": "us1Az",
        "tag": "goodspawn"
    },
    "yQ5Kb": {
        "position": {
            "x": 28,
            "y": 36,
            "z": 1
        },
        "key": "yQ5Kb",
        "tag": "badspawn"
    },
    "ltmKX": {
        "position": {
            "x": 31,
            "y": 39,
            "z": 1
        },
        "key": "ltmKX",
        "tag": "badspawn"
    },
    "M-oEz": {
        "position": {
            "x": 28,
            "y": 40,
            "z": 1
        },
        "key": "M-oEz",
        "tag": "badspawn"
    },
    "m41ih": {
        "position": {
            "x": 29,
            "y": 41,
            "z": 1
        },
        "key": "m41ih",
        "tag": "badspawn"
    },
    "jgdGE": {
        "position": {
            "x": 30,
            "y": 38,
            "z": 1
        },
        "key": "jgdGE",
        "tag": "badspawn"
    },
    "NntQx": {
        "position": {
            "x": 26,
            "y": 38,
            "z": 1
        },
        "key": "NntQx",
        "tag": "goodspawn"
    },
    "BpkyQ": {
        "position": {
            "x": 26,
            "y": 39,
            "z": 1
        },
        "key": "BpkyQ",
        "tag": "goodspawn"
    },
    "qz1MC": {
        "position": {
            "x": 27,
            "y": 38,
            "z": 1
        },
        "key": "qz1MC",
        "tag": "goodspawn"
    },
    "frVG9": {
        "position": {
            "x": 27,
            "y": 39,
            "z": 1
        },
        "key": "frVG9",
        "tag": "goodspawn"
    },
    "6unnB": {
        "position": {
            "x": 26,
            "y": 31,
            "z": 1
        },
        "key": "6unnB",
        "tag": "goodspawn"
    },
    "pwqMf": {
        "position": {
            "x": 26,
            "y": 32,
            "z": 1
        },
        "key": "pwqMf",
        "tag": "goodspawn"
    },
    "Yh5bR": {
        "position": {
            "x": 27,
            "y": 31,
            "z": 1
        },
        "key": "Yh5bR",
        "tag": "goodspawn"
    },
    "v1Rpm": {
        "position": {
            "x": 29,
            "y": 30,
            "z": 1
        },
        "key": "v1Rpm",
        "tag": "badspawn"
    },
    "saekB": {
        "position": {
            "x": 30,
            "y": 33,
            "z": 1
        },
        "key": "saekB",
        "tag": "badspawn"
    },
    "07UAd": {
        "position": {
            "x": 29,
            "y": 34,
            "z": 1
        },
        "key": "07UAd",
        "tag": "badspawn"
    },
    "8xQqb": {
        "position": {
            "x": 31,
            "y": 31,
            "z": 1
        },
        "key": "8xQqb",
        "tag": "badspawn"
    },
    "4PN6l": {
        "position": {
            "x": 27,
            "y": 33,
            "z": 1
        },
        "key": "4PN6l",
        "tag": "badspawn"
    },
    "e0rjN": {
        "position": {
            "x": 26,
            "y": 44,
            "z": 1
        },
        "key": "e0rjN",
        "tag": "goodspawn"
    },
    "l0An0": {
        "position": {
            "x": 27,
            "y": 44,
            "z": 1
        },
        "key": "l0An0",
        "tag": "goodspawn"
    },
    "AIOc2": {
        "position": {
            "x": 26,
            "y": 45,
            "z": 1
        },
        "key": "AIOc2",
        "tag": "goodspawn"
    },
    "tJqk3": {
        "position": {
            "x": 31,
            "y": 45,
            "z": 1
        },
        "key": "tJqk3",
        "tag": "badspawn"
    },
    "guVqS": {
        "position": {
            "x": 27,
            "y": 43,
            "z": 1
        },
        "key": "guVqS",
        "tag": "badspawn"
    },
    "iJc1g": {
        "position": {
            "x": 30,
            "y": 46,
            "z": 1
        },
        "key": "iJc1g",
        "tag": "badspawn"
    },
    "31_dJ": {
        "position": {
            "x": 28,
            "y": 47,
            "z": 1
        },
        "key": "31_dJ",
        "tag": "badspawn"
    },
    "z375t": {
        "position": {
            "x": 43,
            "y": 30,
            "z": 1
        },
        "key": "z375t",
        "tag": "badspawn"
    },
    "gAzyz": {
        "position": {
            "x": 45,
            "y": 33,
            "z": 1
        },
        "key": "gAzyz",
        "tag": "badspawn"
    },
    "d9LnL": {
        "position": {
            "x": 44,
            "y": 34,
            "z": 1
        },
        "key": "d9LnL",
        "tag": "badspawn"
    },
    "SsHF7": {
        "position": {
            "x": 45,
            "y": 30,
            "z": 1
        },
        "key": "SsHF7",
        "tag": "badspawn"
    },
    "Oxj3D": {
        "position": {
            "x": 46,
            "y": 32,
            "z": 1
        },
        "key": "Oxj3D",
        "tag": "badspawn"
    },
    "vUpAG": {
        "position": {
            "x": 42,
            "y": 31,
            "z": 1
        },
        "key": "vUpAG",
        "tag": "goodspawn"
    },
    "9ePOu": {
        "position": {
            "x": 42,
            "y": 32,
            "z": 1
        },
        "key": "9ePOu",
        "tag": "goodspawn"
    },
    "Qgqju": {
        "position": {
            "x": 42,
            "y": 33,
            "z": 1
        },
        "key": "Qgqju",
        "tag": "goodspawn"
    },
    "4XsqP": {
        "position": {
            "x": 43,
            "y": 32,
            "z": 1
        },
        "key": "4XsqP",
        "tag": "goodspawn"
    },
    "No3Es": {
        "position": {
            "x": 43,
            "y": 38,
            "z": 1
        },
        "key": "No3Es",
        "tag": "goodspawn"
    },
    "Xv6Xe": {
        "position": {
            "x": 43,
            "y": 39,
            "z": 1
        },
        "key": "Xv6Xe",
        "tag": "goodspawn"
    },
    "TOuio": {
        "position": {
            "x": 42,
            "y": 38,
            "z": 1
        },
        "key": "TOuio",
        "tag": "goodspawn"
    },
    "Nojqo": {
        "position": {
            "x": 44,
            "y": 36,
            "z": 1
        },
        "key": "Nojqo",
        "tag": "badspawn"
    },
    "AYvqj": {
        "position": {
            "x": 47,
            "y": 39,
            "z": 1
        },
        "key": "AYvqj",
        "tag": "badspawn"
    },
    "LZs6J": {
        "position": {
            "x": 46,
            "y": 37,
            "z": 1
        },
        "key": "LZs6J",
        "tag": "badspawn"
    },
    "cS3t9": {
        "position": {
            "x": 44,
            "y": 41,
            "z": 1
        },
        "key": "cS3t9",
        "tag": "badspawn"
    },
    "QWa6M": {
        "position": {
            "x": 46,
            "y": 40,
            "z": 1
        },
        "key": "QWa6M",
        "tag": "badspawn"
    },
    "_sfvG": {
        "position": {
            "x": 42,
            "y": 39,
            "z": 1
        },
        "key": "_sfvG",
        "tag": "goodspawn"
    },
    "q7aLQ": {
        "position": {
            "x": 42,
            "y": 45,
            "z": 1
        },
        "key": "q7aLQ",
        "tag": "goodspawn"
    },
    "1z69v": {
        "position": {
            "x": 42,
            "y": 46,
            "z": 1
        },
        "key": "1z69v",
        "tag": "goodspawn"
    },
    "YGI-z": {
        "position": {
            "x": 42,
            "y": 47,
            "z": 1
        },
        "key": "YGI-z",
        "tag": "goodspawn"
    },
    "uq1eP": {
        "position": {
            "x": 43,
            "y": 46,
            "z": 1
        },
        "key": "uq1eP",
        "tag": "goodspawn"
    },
    "0o5bj": {
        "position": {
            "x": 43,
            "y": 48,
            "z": 1
        },
        "key": "0o5bj",
        "tag": "badspawn"
    },
    "RkkZC": {
        "position": {
            "x": 45,
            "y": 48,
            "z": 1
        },
        "key": "RkkZC",
        "tag": "badspawn"
    },
    "ghur5": {
        "position": {
            "x": 47,
            "y": 47,
            "z": 1
        },
        "key": "ghur5",
        "tag": "badspawn"
    },
    "hjHwn": {
        "position": {
            "x": 44,
            "y": 43,
            "z": 1
        },
        "key": "hjHwn",
        "tag": "badspawn"
    },
    "6sjXv": {
        "position": {
            "x": 46,
            "y": 45,
            "z": 1
        },
        "key": "6sjXv",
        "tag": "badspawn"
    },
    "Sz9EV": {
        "position": {
            "x": 27,
            "y": 32,
            "z": 1
        },
        "key": "Sz9EV",
        "tag": "goodspawn"
    },
    "GZeT3": {
        "position": {
            "x": 27,
            "y": 45,
            "z": 1
        },
        "key": "GZeT3",
        "tag": "goodspawn"
    },
    "0jcwb": {
        "position": {
            "x": 55,
            "y": 31,
            "z": 1
        },
        "key": "0jcwb",
        "tag": "goodspawn"
    },
    "5f01c": {
        "position": {
            "x": 55,
            "y": 32,
            "z": 1
        },
        "key": "5f01c",
        "tag": "goodspawn"
    },
    "n56pU": {
        "position": {
            "x": 55,
            "y": 33,
            "z": 1
        },
        "key": "n56pU",
        "tag": "goodspawn"
    },
    "Io3PJ": {
        "position": {
            "x": 56,
            "y": 32,
            "z": 1
        },
        "key": "Io3PJ",
        "tag": "goodspawn"
    },
    "SZmUQ": {
        "position": {
            "x": 54,
            "y": 37,
            "z": 1
        },
        "key": "SZmUQ",
        "tag": "goodspawn"
    },
    "LmUTf": {
        "position": {
            "x": 54,
            "y": 38,
            "z": 1
        },
        "key": "LmUTf",
        "tag": "goodspawn"
    },
    "jdLJq": {
        "position": {
            "x": 55,
            "y": 37,
            "z": 1
        },
        "key": "jdLJq",
        "tag": "goodspawn"
    },
    "RTTdo": {
        "position": {
            "x": 55,
            "y": 38,
            "z": 1
        },
        "key": "RTTdo",
        "tag": "goodspawn"
    },
    "SLr0I": {
        "position": {
            "x": 55,
            "y": 42,
            "z": 1
        },
        "key": "SLr0I",
        "tag": "goodspawn"
    },
    "2Ehtv": {
        "position": {
            "x": 55,
            "y": 43,
            "z": 1
        },
        "key": "2Ehtv",
        "tag": "goodspawn"
    },
    "sfloD": {
        "position": {
            "x": 55,
            "y": 44,
            "z": 1
        },
        "key": "sfloD",
        "tag": "goodspawn"
    },
    "MNOAE": {
        "position": {
            "x": 56,
            "y": 43,
            "z": 1
        },
        "key": "MNOAE",
        "tag": "goodspawn"
    },
    "P_4Qa": {
        "position": {
            "x": 57,
            "y": 34,
            "z": 1
        },
        "key": "P_4Qa",
        "tag": "badspawn"
    },
    "575P0": {
        "position": {
            "x": 56,
            "y": 30,
            "z": 1
        },
        "key": "575P0",
        "tag": "badspawn"
    },
    "7iIsx": {
        "position": {
            "x": 59,
            "y": 31,
            "z": 1
        },
        "key": "7iIsx",
        "tag": "badspawn"
    },
    "WaIk8": {
        "position": {
            "x": 59,
            "y": 34,
            "z": 1
        },
        "key": "WaIk8",
        "tag": "badspawn"
    },
    "QZyLc": {
        "position": {
            "x": 60,
            "y": 33,
            "z": 1
        },
        "key": "QZyLc",
        "tag": "badspawn"
    },
    "f-J2y": {
        "position": {
            "x": 56,
            "y": 39,
            "z": 1
        },
        "key": "f-J2y",
        "tag": "badspawn"
    },
    "vipvd": {
        "position": {
            "x": 56,
            "y": 36,
            "z": 1
        },
        "key": "vipvd",
        "tag": "badspawn"
    },
    "JVKLa": {
        "position": {
            "x": 59,
            "y": 39,
            "z": 1
        },
        "key": "JVKLa",
        "tag": "badspawn"
    },
    "LuIGd": {
        "position": {
            "x": 59,
            "y": 37,
            "z": 1
        },
        "key": "LuIGd",
        "tag": "badspawn"
    },
    "0NrgP": {
        "position": {
            "x": 60,
            "y": 38,
            "z": 1
        },
        "key": "0NrgP",
        "tag": "badspawn"
    },
    "hTeaK": {
        "position": {
            "x": 57,
            "y": 41,
            "z": 1
        },
        "key": "hTeaK",
        "tag": "badspawn"
    },
    "4_Uhv": {
        "position": {
            "x": 56,
            "y": 45,
            "z": 1
        },
        "key": "4_Uhv",
        "tag": "badspawn"
    },
    "rCsiE": {
        "position": {
            "x": 60,
            "y": 44,
            "z": 1
        },
        "key": "rCsiE",
        "tag": "badspawn"
    },
    "Y5bYQ": {
        "position": {
            "x": 58,
            "y": 42,
            "z": 1
        },
        "key": "Y5bYQ",
        "tag": "badspawn"
    },
    "HrXXy": {
        "position": {
            "x": 59,
            "y": 45,
            "z": 1
        },
        "key": "HrXXy",
        "tag": "badspawn"
    },
    "_OcRw": {
        "position": {
            "x": 72,
            "y": 43,
            "z": 1
        },
        "key": "_OcRw",
        "tag": "goodspawn"
    },
    "xE7H4": {
        "position": {
            "x": 72,
            "y": 46,
            "z": 1
        },
        "key": "xE7H4",
        "tag": "goodspawn"
    },
    "N5Klq": {
        "position": {
            "x": 72,
            "y": 45,
            "z": 1
        },
        "key": "N5Klq",
        "tag": "goodspawn"
    },
    "yo92Q": {
        "position": {
            "x": 72,
            "y": 44,
            "z": 1
        },
        "key": "yo92Q",
        "tag": "goodspawn"
    },
    "czjzB": {
        "position": {
            "x": 73,
            "y": 47,
            "z": 1
        },
        "key": "czjzB",
        "tag": "badspawn"
    },
    "xV33f": {
        "position": {
            "x": 74,
            "y": 42,
            "z": 1
        },
        "key": "xV33f",
        "tag": "badspawn"
    },
    "VZBjY": {
        "position": {
            "x": 76,
            "y": 43,
            "z": 1
        },
        "key": "VZBjY",
        "tag": "badspawn"
    },
    "dyJvx": {
        "position": {
            "x": 76,
            "y": 45,
            "z": 1
        },
        "key": "dyJvx",
        "tag": "badspawn"
    },
    "KUL2c": {
        "position": {
            "x": 75,
            "y": 46,
            "z": 1
        },
        "key": "KUL2c",
        "tag": "badspawn"
    },
    "6ohho": {
        "position": {
            "x": 72,
            "y": 38,
            "z": 1
        },
        "key": "6ohho",
        "tag": "goodspawn"
    },
    "ZbvaI": {
        "position": {
            "x": 72,
            "y": 39,
            "z": 1
        },
        "key": "ZbvaI",
        "tag": "goodspawn"
    },
    "IMCp7": {
        "position": {
            "x": 71,
            "y": 38,
            "z": 1
        },
        "key": "IMCp7",
        "tag": "goodspawn"
    },
    "neaEK": {
        "position": {
            "x": 71,
            "y": 39,
            "z": 1
        },
        "key": "neaEK",
        "tag": "goodspawn"
    },
    "GDd2-": {
        "position": {
            "x": 74,
            "y": 36,
            "z": 1
        },
        "key": "GDd2-",
        "tag": "badspawn"
    },
    "bWq04": {
        "position": {
            "x": 75,
            "y": 39,
            "z": 1
        },
        "key": "bWq04",
        "tag": "badspawn"
    },
    "YyzeM": {
        "position": {
            "x": 75,
            "y": 37,
            "z": 1
        },
        "key": "YyzeM",
        "tag": "badspawn"
    },
    "Qd2Kq": {
        "position": {
            "x": 73,
            "y": 40,
            "z": 1
        },
        "key": "Qd2Kq",
        "tag": "badspawn"
    },
    "eQ2_T": {
        "position": {
            "x": 74,
            "y": 38,
            "z": 1
        },
        "key": "eQ2_T",
        "tag": "badspawn"
    },
    "AJJgj": {
        "position": {
            "x": 71,
            "y": 31,
            "z": 1
        },
        "key": "AJJgj",
        "tag": "goodspawn"
    },
    "6JSCi": {
        "position": {
            "x": 71,
            "y": 32,
            "z": 1
        },
        "key": "6JSCi",
        "tag": "goodspawn"
    },
    "wqvl6": {
        "position": {
            "x": 71,
            "y": 33,
            "z": 1
        },
        "key": "wqvl6",
        "tag": "goodspawn"
    },
    "CbA26": {
        "position": {
            "x": 71,
            "y": 30,
            "z": 1
        },
        "key": "CbA26",
        "tag": "goodspawn"
    },
    "4AYJj": {
        "position": {
            "x": 74,
            "y": 31,
            "z": 1
        },
        "key": "4AYJj",
        "tag": "badspawn"
    },
    "fvVod": {
        "position": {
            "x": 75,
            "y": 33,
            "z": 1
        },
        "key": "fvVod",
        "tag": "badspawn"
    },
    "pdtoQ": {
        "position": {
            "x": 75,
            "y": 30,
            "z": 1
        },
        "key": "pdtoQ",
        "tag": "badspawn"
    },
    "4hXt2": {
        "position": {
            "x": 76,
            "y": 32,
            "z": 1
        },
        "key": "4hXt2",
        "tag": "badspawn"
    },
    "etiHH": {
        "position": {
            "x": 73,
            "y": 34,
            "z": 1
        },
        "key": "etiHH",
        "tag": "badspawn"
    },
    "1ip-f": {
        "position": {
            "x": 87,
            "y": 42,
            "z": 1
        },
        "key": "1ip-f",
        "tag": "goodspawn"
    },
    "jwbV_": {
        "position": {
            "x": 88,
            "y": 42,
            "z": 1
        },
        "key": "jwbV_",
        "tag": "goodspawn"
    },
    "lXp1s": {
        "position": {
            "x": 91,
            "y": 46,
            "z": 1
        },
        "key": "lXp1s",
        "tag": "badspawn"
    },
    "2pro9": {
        "position": {
            "x": 88,
            "y": 47,
            "z": 1
        },
        "key": "2pro9",
        "tag": "badspawn"
    },
    "lQWVc": {
        "position": {
            "x": 91,
            "y": 44,
            "z": 1
        },
        "key": "lQWVc",
        "tag": "badspawn"
    },
    "_TEFK": {
        "position": {
            "x": 89,
            "y": 45,
            "z": 1
        },
        "key": "_TEFK",
        "tag": "badspawn"
    },
    "g4zoZ": {
        "position": {
            "x": 90,
            "y": 47,
            "z": 1
        },
        "key": "g4zoZ",
        "tag": "badspawn"
    },
    "aot1r": {
        "position": {
            "x": 86,
            "y": 37,
            "z": 1
        },
        "key": "aot1r",
        "tag": "goodspawn"
    },
    "hjZb_": {
        "position": {
            "x": 87,
            "y": 37,
            "z": 1
        },
        "key": "hjZb_",
        "tag": "goodspawn"
    },
    "aRgAk": {
        "position": {
            "x": 87,
            "y": 40,
            "z": 1
        },
        "key": "aRgAk",
        "tag": "goodspawn"
    },
    "fXqiR": {
        "position": {
            "x": 86,
            "y": 40,
            "z": 1
        },
        "key": "fXqiR",
        "tag": "goodspawn"
    },
    "Cktjh": {
        "position": {
            "x": 88,
            "y": 36,
            "z": 1
        },
        "key": "Cktjh",
        "tag": "badspawn"
    },
    "hQHeM": {
        "position": {
            "x": 90,
            "y": 36,
            "z": 1
        },
        "key": "hQHeM",
        "tag": "badspawn"
    },
    "pKetC": {
        "position": {
            "x": 91,
            "y": 38,
            "z": 1
        },
        "key": "pKetC",
        "tag": "badspawn"
    },
    "qQ2Bn": {
        "position": {
            "x": 91,
            "y": 40,
            "z": 1
        },
        "key": "qQ2Bn",
        "tag": "badspawn"
    },
    "6Zck1": {
        "position": {
            "x": 89,
            "y": 40,
            "z": 1
        },
        "key": "6Zck1",
        "tag": "badspawn"
    },
    "uXN1I": {
        "position": {
            "x": 87,
            "y": 33,
            "z": 1
        },
        "key": "uXN1I",
        "tag": "goodspawn"
    },
    "ThLgf": {
        "position": {
            "x": 86,
            "y": 32,
            "z": 1
        },
        "key": "ThLgf",
        "tag": "goodspawn"
    },
    "kmZpr": {
        "position": {
            "x": 86,
            "y": 33,
            "z": 1
        },
        "key": "kmZpr",
        "tag": "goodspawn"
    },
    "Xkcf_": {
        "position": {
            "x": 86,
            "y": 34,
            "z": 1
        },
        "key": "Xkcf_",
        "tag": "goodspawn"
    },
    "uaosa": {
        "position": {
            "x": 88,
            "y": 34,
            "z": 1
        },
        "key": "uaosa",
        "tag": "badspawn"
    },
    "zZtba": {
        "position": {
            "x": 91,
            "y": 33,
            "z": 1
        },
        "key": "zZtba",
        "tag": "badspawn"
    },
    "oxCY7": {
        "position": {
            "x": 89,
            "y": 29,
            "z": 1
        },
        "key": "oxCY7",
        "tag": "badspawn"
    },
    "vnYAj": {
        "position": {
            "x": 88,
            "y": 31,
            "z": 1
        },
        "key": "vnYAj",
        "tag": "badspawn"
    },
    "xv7ho": {
        "position": {
            "x": 91,
            "y": 30,
            "z": 1
        },
        "key": "xv7ho",
        "tag": "badspawn"
    },
    "Xxkwm": {
        "position": {
            "x": 1,
            "y": 40,
            "z": 1
        },
        "key": "Xxkwm",
        "tag": "badspawn"
    },
    "qCje0": {
        "position": {
            "x": 99,
            "y": 29,
            "z": 1
        },
        "key": "qCje0",
        "tag": "goodspawn"
    },
    "cSRML": {
        "position": {
            "x": 100,
            "y": 29,
            "z": 1
        },
        "key": "cSRML",
        "tag": "goodspawn"
    },
    "A7eGx": {
        "position": {
            "x": 99,
            "y": 30,
            "z": 1
        },
        "key": "A7eGx",
        "tag": "goodspawn"
    },
    "SSrAN": {
        "position": {
            "x": 100,
            "y": 30,
            "z": 1
        },
        "key": "SSrAN",
        "tag": "goodspawn"
    },
    "y2AxP": {
        "position": {
            "x": 99,
            "y": 38,
            "z": 1
        },
        "key": "y2AxP",
        "tag": "goodspawn"
    },
    "3LWJW": {
        "position": {
            "x": 100,
            "y": 38,
            "z": 1
        },
        "key": "3LWJW",
        "tag": "goodspawn"
    },
    "EFmMM": {
        "position": {
            "x": 99,
            "y": 37,
            "z": 1
        },
        "key": "EFmMM",
        "tag": "goodspawn"
    },
    "caye1": {
        "position": {
            "x": 100,
            "y": 37,
            "z": 1
        },
        "key": "caye1",
        "tag": "goodspawn"
    },
    "zIdon": {
        "position": {
            "x": 99,
            "y": 42,
            "z": 1
        },
        "key": "zIdon",
        "tag": "goodspawn"
    },
    "uZmQa": {
        "position": {
            "x": 99,
            "y": 43,
            "z": 1
        },
        "key": "uZmQa",
        "tag": "goodspawn"
    },
    "Xpw1O": {
        "position": {
            "x": 100,
            "y": 42,
            "z": 1
        },
        "key": "Xpw1O",
        "tag": "goodspawn"
    },
    "JKf57": {
        "position": {
            "x": 100,
            "y": 43,
            "z": 1
        },
        "key": "JKf57",
        "tag": "goodspawn"
    },
    "fTvQn": {
        "position": {
            "x": 99,
            "y": 31,
            "z": 1
        },
        "key": "fTvQn",
        "tag": "badspawn"
    },
    "6pBRM": {
        "position": {
            "x": 100,
            "y": 32,
            "z": 1
        },
        "key": "6pBRM",
        "tag": "badspawn"
    },
    "ko8kZ": {
        "position": {
            "x": 102,
            "y": 29,
            "z": 1
        },
        "key": "ko8kZ",
        "tag": "badspawn"
    },
    "aXhKe": {
        "position": {
            "x": 101,
            "y": 30,
            "z": 1
        },
        "key": "aXhKe",
        "tag": "badspawn"
    },
    "cP49w": {
        "position": {
            "x": 102,
            "y": 31,
            "z": 1
        },
        "key": "cP49w",
        "tag": "badspawn"
    },
    "E1YL1": {
        "position": {
            "x": 99,
            "y": 34,
            "z": 1
        },
        "key": "E1YL1",
        "tag": "badspawn"
    },
    "SUIi5": {
        "position": {
            "x": 100,
            "y": 34,
            "z": 1
        },
        "key": "SUIi5",
        "tag": "badspawn"
    },
    "2ncLT": {
        "position": {
            "x": 100,
            "y": 35,
            "z": 1
        },
        "key": "2ncLT",
        "tag": "badspawn"
    },
    "ZliSk": {
        "position": {
            "x": 101,
            "y": 38,
            "z": 1
        },
        "key": "ZliSk",
        "tag": "badspawn"
    },
    "fIo49": {
        "position": {
            "x": 102,
            "y": 38,
            "z": 1
        },
        "key": "fIo49",
        "tag": "badspawn"
    },
    "d9-5H": {
        "position": {
            "x": 102,
            "y": 37,
            "z": 1
        },
        "key": "d9-5H",
        "tag": "badspawn"
    },
    "qIDeD": {
        "position": {
            "x": 102,
            "y": 34,
            "z": 1
        },
        "key": "qIDeD",
        "tag": "badspawn"
    },
    "wmYGR": {
        "position": {
            "x": 102,
            "y": 43,
            "z": 1
        },
        "key": "wmYGR",
        "tag": "badspawn"
    },
    "DdlY6": {
        "position": {
            "x": 99,
            "y": 41,
            "z": 1
        },
        "key": "DdlY6",
        "tag": "badspawn"
    },
    "hs4h0": {
        "position": {
            "x": 100,
            "y": 40,
            "z": 1
        },
        "key": "hs4h0",
        "tag": "badspawn"
    },
    "xryzZ": {
        "position": {
            "x": 100,
            "y": 45,
            "z": 1
        },
        "key": "xryzZ",
        "tag": "badspawn"
    },
    "PxLtQ": {
        "position": {
            "x": 99,
            "y": 45,
            "z": 1
        },
        "key": "PxLtQ",
        "tag": "badspawn"
    },
    "PLeqJ": {
        "position": {
            "x": 102,
            "y": 40,
            "z": 1
        },
        "key": "PLeqJ",
        "tag": "badspawn"
    },
    "dy-VD": {
        "position": {
            "x": 112,
            "y": 30,
            "z": 1
        },
        "key": "dy-VD",
        "tag": "goodspawn"
    },
    "Mrr4F": {
        "position": {
            "x": 113,
            "y": 31,
            "z": 1
        },
        "key": "Mrr4F",
        "tag": "goodspawn"
    },
    "TSARj": {
        "position": {
            "x": 112,
            "y": 32,
            "z": 1
        },
        "key": "TSARj",
        "tag": "goodspawn"
    },
    "brg-e": {
        "position": {
            "x": 112,
            "y": 31,
            "z": 1
        },
        "key": "brg-e",
        "tag": "goodspawn"
    },
    "VD2s_": {
        "position": {
            "x": 114,
            "y": 33,
            "z": 1
        },
        "key": "VD2s_",
        "tag": "badspawn"
    },
    "30xPA": {
        "position": {
            "x": 115,
            "y": 29,
            "z": 1
        },
        "key": "30xPA",
        "tag": "badspawn"
    },
    "U8Smo": {
        "position": {
            "x": 115,
            "y": 31,
            "z": 1
        },
        "key": "U8Smo",
        "tag": "badspawn"
    },
    "4Gq1S": {
        "position": {
            "x": 117,
            "y": 32,
            "z": 1
        },
        "key": "4Gq1S",
        "tag": "badspawn"
    },
    "XorIX": {
        "position": {
            "x": 118,
            "y": 30,
            "z": 1
        },
        "key": "XorIX",
        "tag": "badspawn"
    },
    "TNy40": {
        "position": {
            "x": 112,
            "y": 39,
            "z": 1
        },
        "key": "TNy40",
        "tag": "goodspawn"
    },
    "MeCuz": {
        "position": {
            "x": 113,
            "y": 39,
            "z": 1
        },
        "key": "MeCuz",
        "tag": "goodspawn"
    },
    "HW6y7": {
        "position": {
            "x": 113,
            "y": 36,
            "z": 1
        },
        "key": "HW6y7",
        "tag": "goodspawn"
    },
    "CnqO5": {
        "position": {
            "x": 112,
            "y": 36,
            "z": 1
        },
        "key": "CnqO5",
        "tag": "goodspawn"
    },
    "aXZ-c": {
        "position": {
            "x": 114,
            "y": 35,
            "z": 1
        },
        "key": "aXZ-c",
        "tag": "badspawn"
    },
    "Bjm7Y": {
        "position": {
            "x": 115,
            "y": 36,
            "z": 1
        },
        "key": "Bjm7Y",
        "tag": "badspawn"
    },
    "TrPv8": {
        "position": {
            "x": 117,
            "y": 38,
            "z": 1
        },
        "key": "TrPv8",
        "tag": "badspawn"
    },
    "Y8AY2": {
        "position": {
            "x": 116,
            "y": 37,
            "z": 1
        },
        "key": "Y8AY2",
        "tag": "badspawn"
    },
    "aqzh3": {
        "position": {
            "x": 118,
            "y": 37,
            "z": 1
        },
        "key": "aqzh3",
        "tag": "badspawn"
    },
    "KzTJt": {
        "position": {
            "x": 112,
            "y": 44,
            "z": 1
        },
        "key": "KzTJt",
        "tag": "goodspawn"
    },
    "CpVoj": {
        "position": {
            "x": 113,
            "y": 44,
            "z": 1
        },
        "key": "CpVoj",
        "tag": "goodspawn"
    },
    "ldA84": {
        "position": {
            "x": 112,
            "y": 45,
            "z": 1
        },
        "key": "ldA84",
        "tag": "goodspawn"
    },
    "pIBoO": {
        "position": {
            "x": 113,
            "y": 45,
            "z": 1
        },
        "key": "pIBoO",
        "tag": "goodspawn"
    },
    "Xmuz7": {
        "position": {
            "x": 116,
            "y": 40,
            "z": 1
        },
        "key": "Xmuz7",
        "tag": "badspawn"
    },
    "enQYf": {
        "position": {
            "x": 114,
            "y": 44,
            "z": 1
        },
        "key": "enQYf",
        "tag": "badspawn"
    },
    "sNfEj": {
        "position": {
            "x": 117,
            "y": 45,
            "z": 1
        },
        "key": "sNfEj",
        "tag": "badspawn"
    },
    "oukTJ": {
        "position": {
            "x": 118,
            "y": 39,
            "z": 1
        },
        "key": "oukTJ",
        "tag": "badspawn"
    },
    "n-gAI": {
        "position": {
            "x": 114,
            "y": 38,
            "z": 1
        },
        "key": "n-gAI",
        "tag": "badspawn"
    },
    "GGtZl": {
        "position": {
            "x": 128,
            "y": 43,
            "z": 1
        },
        "key": "GGtZl",
        "tag": "goodspawn"
    },
    "I_4ns": {
        "position": {
            "x": 128,
            "y": 42,
            "z": 1
        },
        "key": "I_4ns",
        "tag": "goodspawn"
    },
    "yvX-b": {
        "position": {
            "x": 129,
            "y": 42,
            "z": 1
        },
        "key": "yvX-b",
        "tag": "goodspawn"
    },
    "TDT3z": {
        "position": {
            "x": 129,
            "y": 43,
            "z": 1
        },
        "key": "TDT3z",
        "tag": "goodspawn"
    },
    "tHM9c": {
        "position": {
            "x": 130,
            "y": 45,
            "z": 1
        },
        "key": "tHM9c",
        "tag": "badspawn"
    },
    "haMsh": {
        "position": {
            "x": 132,
            "y": 46,
            "z": 1
        },
        "key": "haMsh",
        "tag": "badspawn"
    },
    "wzNAF": {
        "position": {
            "x": 133,
            "y": 44,
            "z": 1
        },
        "key": "wzNAF",
        "tag": "badspawn"
    },
    "6YGYp": {
        "position": {
            "x": 133,
            "y": 42,
            "z": 1
        },
        "key": "6YGYp",
        "tag": "badspawn"
    },
    "SZEUk": {
        "position": {
            "x": 131,
            "y": 41,
            "z": 1
        },
        "key": "SZEUk",
        "tag": "badspawn"
    },
    "pkyzK": {
        "position": {
            "x": 128,
            "y": 37,
            "z": 1
        },
        "key": "pkyzK",
        "tag": "goodspawn"
    },
    "MqKgs": {
        "position": {
            "x": 128,
            "y": 38,
            "z": 1
        },
        "key": "MqKgs",
        "tag": "goodspawn"
    },
    "dajkY": {
        "position": {
            "x": 128,
            "y": 36,
            "z": 1
        },
        "key": "dajkY",
        "tag": "goodspawn"
    },
    "xAjZu": {
        "position": {
            "x": 129,
            "y": 37,
            "z": 1
        },
        "key": "xAjZu",
        "tag": "goodspawn"
    },
    "7n3k3": {
        "position": {
            "x": 132,
            "y": 39,
            "z": 1
        },
        "key": "7n3k3",
        "tag": "badspawn"
    },
    "8A92R": {
        "position": {
            "x": 133,
            "y": 35,
            "z": 1
        },
        "key": "8A92R",
        "tag": "badspawn"
    },
    "xNSNC": {
        "position": {
            "x": 130,
            "y": 39,
            "z": 1
        },
        "key": "xNSNC",
        "tag": "badspawn"
    },
    "1Q618": {
        "position": {
            "x": 131,
            "y": 37,
            "z": 1
        },
        "key": "1Q618",
        "tag": "badspawn"
    },
    "XQiI6": {
        "position": {
            "x": 129,
            "y": 35,
            "z": 1
        },
        "key": "XQiI6",
        "tag": "badspawn"
    },
    "9KbtI": {
        "position": {
            "x": 129,
            "y": 29,
            "z": 1
        },
        "key": "9KbtI",
        "tag": "goodspawn"
    },
    "NJy6O": {
        "position": {
            "x": 131,
            "y": 29,
            "z": 1
        },
        "key": "NJy6O",
        "tag": "goodspawn"
    },
    "qsleN": {
        "position": {
            "x": 130,
            "y": 29,
            "z": 1
        },
        "key": "qsleN",
        "tag": "goodspawn"
    },
    "idqDk": {
        "position": {
            "x": 130,
            "y": 30,
            "z": 1
        },
        "key": "idqDk",
        "tag": "goodspawn"
    },
    "KDbl-": {
        "position": {
            "x": 132,
            "y": 33,
            "z": 1
        },
        "key": "KDbl-",
        "tag": "badspawn"
    },
    "R9wUx": {
        "position": {
            "x": 133,
            "y": 31,
            "z": 1
        },
        "key": "R9wUx",
        "tag": "badspawn"
    },
    "PlfsK": {
        "position": {
            "x": 128,
            "y": 32,
            "z": 1
        },
        "key": "PlfsK",
        "tag": "badspawn"
    },
    "dF5iA": {
        "position": {
            "x": 129,
            "y": 33,
            "z": 1
        },
        "key": "dF5iA",
        "tag": "badspawn"
    },
    "U5OYX": {
        "position": {
            "x": 132,
            "y": 30,
            "z": 1
        },
        "key": "U5OYX",
        "tag": "badspawn"
    },
    "5U4Gp": {
        "position": {
            "x": 26,
            "y": 22,
            "z": 1
        },
        "key": "5U4Gp",
        "tag": "goodspawn"
    },
    "4ARzL": {
        "position": {
            "x": 25,
            "y": 23,
            "z": 1
        },
        "key": "4ARzL",
        "tag": "goodspawn"
    },
    "KFLnV": {
        "position": {
            "x": 27,
            "y": 23,
            "z": 1
        },
        "key": "KFLnV",
        "tag": "goodspawn"
    },
    "KykNZ": {
        "position": {
            "x": 26,
            "y": 24,
            "z": 1
        },
        "key": "KykNZ",
        "tag": "goodspawn"
    },
    "wIRoc": {
        "position": {
            "x": 26,
            "y": 23,
            "z": 1
        },
        "key": "wIRoc",
        "tag": "center"
    },
    "16RKI": {
        "position": {
            "x": 88,
            "y": 43,
            "z": 1
        },
        "key": "16RKI",
        "tag": "goodspawn"
    },
    "exlSh": {
        "position": {
            "x": 15,
            "y": 40,
            "z": 1
        },
        "key": "exlSh",
        "tag": "badspawn"
    },
    "-Vn7q": {
        "position": {
            "x": 29,
            "y": 44,
            "z": 1
        },
        "key": "-Vn7q",
        "tag": "badspawn"
    },
    "Q7u0l": {
        "position": {
            "x": 88,
            "y": 38,
            "z": 1
        },
        "key": "Q7u0l",
        "tag": "badspawn"
    },
    "REjMG": {
        "position": {
            "x": 129,
            "y": 41,
            "z": 1
        },
        "key": "REjMG",
        "tag": "badspawn"
    }
}